import { HOME, DASHBOARD } from '../../config/routing/paths';

export const config = [
  {
    label: 'Home',
    path: HOME,
  },
  {
    label: 'Dashboard',
    path: DASHBOARD,
  }
];
